export default __webpack_public_path__ + "static/media/26.62522799.jpg";